module.exports = __webpack_public_path__ + "static/media/webvr-support-chrome.e02ba33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webvr-support-chrome.png
// module id = 1528
// module chunks = 0